import { LeftCircleFilled } from '@ant-design/icons';
import { Carousel } from 'antd';
import { CarouselProps } from 'antd/lib/carousel';
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import { GenericSliderData } from 'src/common/models/genericSlider';
import styles from './AppSlider.module.scss';

type Props = {
    content?: GenericSliderData;
};

function SliderArrowLeft(props: { className?: string; onClick?: any; rotate180?: boolean }) {
    return (
        <div
            onClick={props.onClick}
            className={classNames(props.className, {
                'rotate-180': props.rotate180,
            })}
        >
            <LeftCircleFilled className='arrow' rotate={props.rotate180 ? 180 : 0} />
        </div>
    );
}

function AppSlider({ content }: Props) {
    const sliders = useMemo(
        () => content?.slides.filter((sl) => sl?.slideEnabled?.value === '1'),
        [content?.slides]
    );
    const renderedSliders = useMemo(
        () =>
            sliders?.map((item, ind) => {
                const imgPath = item.slideImage?.src;
                return (
                    <div key={ind}>
                        <img className='w-full' src={imgPath} alt=''></img>
                        <div
                            className='w-full'
                            dangerouslySetInnerHTML={{ __html: item.slideImageCaption?.value }}
                        ></div>
                    </div>
                );
            }),
        [sliders]
    );
    const slideProps: CarouselProps = {
        infinite: false,
        arrows: true,
        prevArrow: <SliderArrowLeft />,
        nextArrow: <SliderArrowLeft rotate180 />,
        appendDots: (dots) => <div>{dots}</div>,
        customPaging: () => <div></div>,
    };
    return (
        <div className={styles['container']}>
            <div
                className='mb-3'
                dangerouslySetInnerHTML={{ __html: content?.sliderHeader?.value || '' }}
            ></div>
            <div className={classNames('px-9 md:px-28 pb-6', styles['sliders-container'])}>
                <Carousel {...slideProps}>{renderedSliders}</Carousel>
            </div>
            <div></div>
        </div>
    );
}

export default memo(AppSlider);
